import { render, staticRenderFns } from "./homeDashboardTerminationStatistics.vue?vue&type=template&id=86889b0c&scoped=true"
import script from "./homeDashboardTerminationStatistics.vue?vue&type=script&lang=js"
export * from "./homeDashboardTerminationStatistics.vue?vue&type=script&lang=js"
import style0 from "./homeDashboardTerminationStatistics.vue?vue&type=style&index=0&id=86889b0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86889b0c",
  null
  
)

export default component.exports